import { useIntermediateProductListContext } from "../IntermediateProductListContext";
import { AutoGrid } from "src/components/Grid/layout/AutoGrid";
import { useIsProductUxV2 } from "src/hooks/useIsProductUxV2";
import { BrandCollectionStateError } from "src/api/client-api/brand/BrandCollectionStateError";
import { isBrandCollectionError } from "src/api/client-api/brand/useGetAllBrand";
import { Box, Stack, useTheme } from "@mui/material";

export const IntermediateProductGrid = () => {
    const isProductUxV2 = useIsProductUxV2();
    const {
        gridKey,
        mrt_columns,
        appSearch,
        brandCollectionState,
        products,
        isRefetching,
        isReady,
        gridConfiguration,
        menuItems,
        tableActions,
        totalItems,
        pagination,
        refetchBrands,
    } = useIntermediateProductListContext();

    const isLoading = isReady === false || isRefetching === true;
    const theme = useTheme();
    const hasBrandCollectionError = isBrandCollectionError(brandCollectionState);

    return (
        <Stack gap={theme.spacing(2)}>
            {hasBrandCollectionError && (
                <BrandCollectionStateError state={brandCollectionState} onRetry={refetchBrands} />
            )}
            <Box>
                <AutoGrid
                    appearance={isProductUxV2 ? "hub" : undefined}
                    enableColumnResizing={!isProductUxV2}
                    enableColumnsAction
                    gridKey={gridKey}
                    columns={mrt_columns}
                    data={products}
                    isLoading={isLoading}
                    totalItems={totalItems}
                    searchParams={appSearch}
                    menuItems={menuItems}
                    tableActions={tableActions}
                    columnsConfig={gridConfiguration}
                    pagination={pagination}
                />
            </Box>
        </Stack>
    );
};
